<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="no" type="number"/>
            </div>
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="title"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="status" type="select2" :items="statuses"
                        value-field="value" display-field="${item.key}" :label="false"
                            :options="{placeholder: $t('Status')}"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="dev_status" type="select2" :items="devStatuses"
                            value-field="value" display-field="${item.key}" :label="false"
                            :options="{placeholder: $t('Dev. Status')}"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="priority" type="select2" :items="priorities"
                        value-field="value" display-field="${item.key}" :label="false"
                            :options="{placeholder: $t('Priority')}"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="module_name" type="select2" :items="modulesNames"
                        value-field="value" display-field="${item.key}" :label="false"
                            :options="{placeholder: $t('Module Name')}"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="payment_status" type="select2" :items="paymentStatuses"
                        value-field="value" display-field="${item.key}" :label="false"
                            :options="{placeholder: $t('Payment Status')}"/>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";


  const {mapState, mapActions} = createNamespacedHelpers('featureRequest');

  export default {
    name: "FeatureRequestSearch",
    components: {InputWidget},
    computed: {
      ...mapState({
        searchModel: state => state.tableData[state.tableSource].searchModel,
        priorities: state => state.priorities,
        modulesNames: state => state.modulesNames,
        devStatuses: state => state.devStatuses,
        statuses: state => state.statuses,
        paymentStatuses: state => state.paymentStatuses,
      }),
    },
    data() {
      return {
      }
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.resetTableDataPaginationPage();
        this.getTableData();
      },
      onResetClick() {
        this.resetTable();
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
